var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4038_1686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.08051 8.52C8.03384 8.51333 7.97384 8.51333 7.92051 8.52C6.74718 8.48 5.81384 7.52 5.81384 6.33999C5.81384 5.13332 6.78718 4.15332 8.00051 4.15332C9.20718 4.15332 10.1872 5.13332 10.1872 6.33999C10.1805 7.52 9.25384 8.48 8.08051 8.52Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4932 12.9201C11.3065 14.0067 9.73316 14.6667 7.99982 14.6667C6.26647 14.6667 4.69314 14.0067 3.50647 12.9201C3.57314 12.2934 3.97314 11.6801 4.68647 11.2001C6.51314 9.98674 9.49982 9.98674 11.3132 11.2001C12.0265 11.6801 12.4265 12.2934 12.4932 12.9201Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8.00001C14.6667 4.31811 11.6819 1.33334 8.00004 1.33334C4.31814 1.33334 1.33337 4.31811 1.33337 8.00001C1.33337 11.6819 4.31814 14.6667 8.00004 14.6667Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4038_1686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCircle);
export default __webpack_public_path__ + "static/media/profile-circle.714c19b4cc62bc55ec4273335727b4bd.svg";
export { ForwardRef as ReactComponent };